import { API } from './API';

const DEFAULT_OPTIONS = {
  baseUrl: 'graphql',
};

const constantFields = `
  name
  id
`;

const workflowFields = `
  completed
  type
  questions {
    id
    root
    text
    answered
    answers {
      completesWorkflow
      label
      next
      selected
      selectedBy
      text
      uiAction
    }
  }
`;

const findingFields = `
  analysis
  category
  created
  createdBy
  id
  jurisdiction
  name
  orgId
  priority
  promotedToId
  status
  type
  workflows { ${workflowFields} }
`;

export class FindingAPI extends API {
  constructor(options = {}) {
    super({ ...DEFAULT_OPTIONS, ...options });
  }

  addOwner = ({
    findingId,
    personId,
    ownerId,
    ownerType,
  }) => {
    if (['analyst', 'responder', 'manager'].indexOf(ownerType) < 0) {
      throw new Error('Incorrect owner type!');
    }

    const mutation = `
      mutation Finding($findingId: ID!, $personId: ID!, $ownerId: ID!,
        $ownerType: String) {
        addOwner(findingId: $findingId, personId: $personId, ownerId: $ownerId,
          ownerType: $ownerType) {
          ${findingFields}
        }
      }
    `;

    const data = {
      findingId,
      personId,
      ownerId,
      ownerType,
    };

    return super.get({ query: mutation, data })
      .then(({ addOwner: finding }) => ({ finding }));
  };


  /* Get all findings for an org, and jurisdiction.

    @param {string}  jurisdiction - The value of the jurisdictions for the
      findings returned. Return a negative for everything but the passed value.
      (e.g. "-30" will return all Findings that jurisdiction != "30")
    @param {string}  orgId - The UUID of Organization
    @param {string}  personId - The UUID of the person logged in for
      populating the 'x-blu-acting-person' field

    returns: [Array] of {Findings}

  */
  get({
    orgId,
    personId,
    jurisdiction,
  }) {
    const query = `
      query Finding($jurisdiction: Int, $orgId: ID, $personId: ID!) {
        listFindings(
          jurisdiction: $jurisdiction,
          orgId: $orgId,
          personId: $personId) {
            ${findingFields}
          }

        getConstants(personId: $personId) {
          resolution { ${constantFields} }
          category { ${constantFields} }
          status { ${constantFields} }
          type { ${constantFields} }
          uiAction { ${constantFields} }
        }
      }
    `;
    const data = {
      orgId,
      personId,
      jurisdiction: parseInt(jurisdiction, 10),
    };

    return super
      .get({ query, data })
      .then(({ listFindings: findings, getConstants: constants }) =>
        ({ findings, constants }));
  }


  // Find specific finding by id.
  findById(orgId, id) {
    const query = `
      query Finding($id: ID!) {
        getFinding(id: $id) { ${findingFields} }
      }
    `;
    const data = { id };
    return super
      .get({ query, data })
      .then(({ getFinding: finding }) => ({ finding }));
  }

  submitQuestion({
    answerText,
    findingId,
    personId,
    questionId,
    type,
  }) {
    const mutation = `
    mutation Finding(
      $answerText: String,
      $findingId: ID,
      $personId: ID,
      $questionId: ID,
      $type: String) {
      answerWorkflowQuestion(
        answerText: $answerText,
        findingId: $findingId,
        personId: $personId,
        questionId: $questionId,
        type: $type) {
        ${findingFields}
      }
    }
    `;

    const data = {
      answerText,
      findingId,
      personId,
      questionId,
      type,
    };

    return super
      .get({ query: mutation, data })
      .then(({ answerWorkflowQuestion: finding }) => ({ finding }));
  }
}



// WEBPACK FOOTER //
// ./src/lib/api/FindingAPI.js